import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import MultiSelect from "react-multi-select-component";
import { toast } from 'react-toastify';
import loadScripts from '../../../dassets/js/custom';
class Confirmation extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.setHauSelected = this.setHauSelected.bind(this);
        this.setRRSelected = this.setRRSelected.bind(this);
        this.setKYCSelected = this.setKYCSelected.bind(this);
        this.onChangeDocument = this.onChangeDocument.bind(this);
        this.kyc_docs = [];
        this.state = {
            heard_about_us: this.props.fieldValues.heard_about_us,
            receive_reports: this.props.fieldValues.receive_reports,
            kyc_docs: [...this.props.fieldValues.kyc_docs, { label: this.props.fieldValues.id_type, value: this.props.fieldValues.id_type}]
        }
    }

    setHauSelected(selected) {
        if (selected.length) {
            this.setState({ heard_about_us: selected });
        }
    }

    setRRSelected(selected) {
        if (selected.length) {
            this.setState({ receive_reports: selected });
        }
    }

    setKYCSelected(selected) {
        if (selected.length) {
            this.setState({ kyc_docs: selected });
        }
    }

    onChangeDocument(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
    }

    createDoc() {
        return this.state.kyc_docs.map((x, i) => {
            return <Form.Group key={i} className="col-lg-3 col-md-4 col-sm-6">
                <label htmlFor="attachments"><i className="fa fa-paperclip"></i> {x.value}<span className="text-danger">*</span></label>
                <Form.Control name={x.value} onChange={this.onChangeDocument} type="file" className="form-control" accept=".jpeg,.jpg,.gif,.png" required />
            </Form.Group>
        })
    }

    saveAndContinue(e) {
        e.preventDefault();
        let kyc_docs = [];
        document.querySelectorAll("input[type='file']").forEach((el, i) => {
            let file = el.files[0];
            let path = `iform_documents_${new Date().getTime()}${i}.png`;
            let kyc_doc = { "name": el.name, "file": file, "path": path };
            kyc_docs.push(kyc_doc);
        });

        // Get values via this.refs
        let data = {
            heard_about_us: this.state.heard_about_us.map(el => el.value),
            kyc_docs: kyc_docs.map(el => {
                return { "name": el.name, "path": el.path }
            }),
            prefered_account: this.refs.prefered_account.value,
            receive_reports: this.state.receive_reports.map(el => el.value),
            documents: kyc_docs,
        }

        this.props.saveValues(data)
        this.props.submit();
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Account Details</h4>
                                <p>For the KYC documents, please, select utility bill and any other document you wish to upload.</p>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Preferred Account<span className="text-danger">*</span></label>
                                            <select ref="prefered_account" required className="form-control" defaultValue={this.props.fieldValues.prefered_account}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Cash Account">Cash Account</option>
                                                <option value="Direct Card Settlement">Direct Cash Settlement</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>How did you hear about us?</label>
                                            <MultiSelect
                                                options={[
                                                    { label: "Website", value: "Website" },
                                                    { label: "Newspaper", value: "Newspaper" },
                                                    { label: "Radio Jingles", value: "Radio Jingles" },
                                                    { label: "Seminars", value: "Seminars" },
                                                    { label: "Word of Mouth", value: "Word of Mouth" },
                                                    { label: "Social Media", value: "Social Media" },
                                                    { label: "Others", value: "Others" }
                                                ]}
                                                value={this.state.heard_about_us}
                                                onChange={this.setHauSelected}
                                                labelledBy={"Select..."}
                                            />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Indicate reports you would like to receive</label>
                                            <MultiSelect
                                                options={[
                                                    { label: "Dynamic Portfolio Daily Investment Alerts", value: "Dynamic Portfolio Daily Investment Alerts" },
                                                    { label: "Dynamic Portfolio Weekly Investment Alerts", value: "Dynamic Portfolio Weekly Investment Alerts" },
                                                    { label: "Other available reports", value: "Other available reports" }
                                                ]}
                                                value={this.state.receive_reports}
                                                onChange={this.setRRSelected}
                                                labelledBy={"Select..."}
                                            />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>KYC Documents<span className="text-danger">*</span></label>
                                            <MultiSelect
                                                options={[
                                                    { label: "International Passport", value: "International Passport" },
                                                    { label: "Driver's Licence", value: "Driver's Licence" },
                                                    { label: "National ID Card", value: "National ID Card" },
                                                    { label: "Permanent Voters Card", value: "Permanent Voters Card" },
                                                    { label: "Utility Bill", value: "Utility Bill", disabled: true},
                                                    { label: "Special Control Unit on Money Laundering (SCUML) Certificate as applicable to applicant", value: "Special Control Unit on Money Laundering (SCUML) Certificate as applicable to applicant" }
                                                ]}
                                                value={this.state.kyc_docs}
                                                onChange={this.setKYCSelected}
                                                labelledBy={"Select..."}
                                                required
                                            />
                                        </Form.Group>
                                        {this.createDoc()}
                                    </div>
                                    <div><p>I agree to terms and conditions of the Dynamic Portfolio.</p></div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Submit</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Confirmation;